import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

export enum DROPDOWN_TYPES {
  RESOURCE_KIND = 'resourceKind',
  RESOURCE_TYPE = 'resourceType',
  RESOURCE_KEYWORD = 'resourceKeyword',
  RESOURCE_DIRECTION_TYPE = 'resourceDirectionType',
  RESOURCE_SIZE_TYPE = 'resourceSideType',
  SCENE_TYPE = 'sceneType',
  OPTION_TYPE_CATEGORY = 'optionTypeCategory',
}

const DROPDOWNS_URL = `/api/dropdowns`;

export const dropdownsApi = createApi({
  reducerPath: 'dropdowns.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['dropdowns'],
  endpoints: (builder) => ({
    getDropdownItems: builder.query({
      query: (type) => ({ url: `${DROPDOWNS_URL}?type=${type}` }),
      providesTags: ['dropdowns'],
    }),
  }),
});

export const { useGetDropdownItemsQuery } = dropdownsApi;
